import { getPropertyImagesByInternalService } from '~/services/AccommodationService';

import ApiError from '~/types/ApiError';

export const ACCOMMODATION_INTERNAL_SERVICE = 'reservation';
// Fetch more than the sync cap so images already on the offer are filtered out
// without crowding out genuinely new ones.
export const SYNC_PROPERTY_FETCH_LIMIT = 75;

export interface AccomPropertyImage {
  id: string;
  publicId: string;
  title?: string;
  alreadyOnOffer: boolean;
}

export async function fetchAccomPropertyImages(
  propertyId: string,
  existingPublicIds: Set<string>,
): Promise<Array<AccomPropertyImage>> {
  const response = await getPropertyImagesByInternalService({
    internalService: ACCOMMODATION_INTERNAL_SERVICE,
    internalServiceId: propertyId,
    limit: SYNC_PROPERTY_FETCH_LIMIT,
  });

  return (response.result?.images ?? []).map((image) => ({
    id: image.id,
    publicId: image.imageId,
    title: image.title ?? undefined,
    alreadyOnOffer: existingPublicIds.has(image.imageId),
  }));
}

export function isPropertyNotMappedError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
